// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a1-0";
export var optionCard = "_a1-1";